import { createActions } from 'redux-actions'

export const constants = {
  GET_CALL_TAKER: 'GET_CALL_TAKER',
  FETCH_ALL_CALL_TAKERS: 'FETCH_ALL_CALL_TAKERS',
  CREATE_CALL_TAKER: 'CREATE_CALL_TAKER',
  UPDATE_CALL_TAKER: 'UPDATE_CALL_TAKER',
  UPDATE_USER_FORM_FIELD: 'UPDATE_USER_FORM_FIELD',
  RESET_USER_FORM_FIELDS: 'RESET_USER_FORM_FIELDS',
}

export const actions = createActions({
  GET_CALL_TAKER: {
    REQUEST: ({ id }) => ({ id }),
    SUCCESS: result => result,
    FAILURE: error => error
  },
  FETCH_ALL_CALL_TAKERS: {
    REQUEST: (filters) => (filters || {}),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  CREATE_CALL_TAKER: {
    REQUEST: payload => payload,
    SUCCESS: success => success,
    FAILURE: error => error
  },
  UPDATE_CALL_TAKER: {
    REQUEST: payload => payload,
    SUCCESS: success => success,
    FAILURE: error => error
  },
  UPDATE_USER_FORM_FIELD: (field, value) => ({ field, value }),
  RESET_USER_FORM_FIELDS: (showMessage = true, fieldData = {}) => ({ showMessage, fieldData }),
})